//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    index
} from "@/assets/api/dataBase.js";
import {
    utils
} from "@/assets/utils/utils.js";
import dbmap from "@/assets/dbs/hashmap.js"
import provinceBankJson from '@/assets/api/bank.json'
import text from '@/assets/api/text.json'
import Alert from '@/components/alert/index'
import axios from 'axios'
import Vue from 'vue'
export default {
    components: {Alert},
    data() {
        return {
            data: '',
            that: this,
            isAlertShow: false,
            provinceBankJson: [],
            isAllRrquridSuccess: false,
            isBankCode: false,
            bankCode: '0',
            portalType: "",
            isProductCode: false,
            productCode: '6000', //贷款产品
            queryBankCode: '',
            
            stream:'', //stream
            querystream:'',
            // isstream:false, // 是否填写stream
            productList:[],
            textList:[],
        }
    },
    created(){
        this.provinceBankJson = provinceBankJson;
        this.productListFun();
        localStorage.setItem('productCode',this.productCode);
        this.textList = text[0]; // 默认值 6000
    },
    mounted(){
        let version = "2026-01-20 14:00 update"
        console.log(version)

        let arr = this.provinceBankJson;
        let newarr = arr.filter(item=> item.bankCode !== 'HBCQ' && item.bankCode!=='HBGD')

        this.provinceBankJson = newarr

        this.provinceBankJson.map((item, index) => {
            if(this.$route.query.bankCode === item.bankCode){
                this.queryBankCode = this.$route.query.bankCode;
                return
            }
            return
        });
        this.bankCode = this.queryBankCode || "0";
        this.querystream = this.$route.query.stream;
        this.stream = this.querystream || null;

    },
    filters:{
        bankCodef(val,that){
            if (val) {
                let name = ''
                that.provinceBankJson.map((item, index) => {
                    if (val == item.bankCode) {
                        name = item.bankName
                    }
                });
                return name
            } else {
                return '--'
            }
        },
        // productCodef(val){
        //     if(val == '6000'){
        //         return val = '个人经营性贷款'
        //     }
        // }
    },
    methods: {
        changeProduct(){
            localStorage.setItem('productCode',this.productCode);
            text.map((item, index) => {
                if(this.productCode === item.code){
                    this.textList = item
                    return
                }
                return
            });
            console.log(this.textList);

        },
        productListFun(){
            let url =  process.env.BASE_API2 +'prdList'
            axios({
                method: 'post',
                url: url,
                data: {}
            }).then(({data})=>{
                if(data){ 
                   this.productList = data.responseData.list
                }
            })
         
        },
        start() {
            index({
                productCode:this.productCode,
                portalType: this.portalType,
                bankCode: this.bankCode
            }).then(result => {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    this.$router.push({
                        path: url
                    });
                }
            });
        },
        //开始申请
       apply(item) {
            this.isAllRrquridSuccess = false 
            // this.streamChange();
            this.bankCodeChange();
            let statusInfo =  this.isAllSuccess()
            if(!statusInfo){
                dbmap.set('productCode',this.productCode)
                this.$refs.isAlertShow.showAlert()
                this.data = item
            }else{
                window.scrollTo(0, 0);
            }
        },
        closeAlertp(item){
            this.$refs.isAlertShow.closeAlert();
            if(item == 'login'){
                this.$router.push({
                    path:"/login"
                });
            }else if(item == 'action'){
                this.portalType = "register";
                this.start();
            }
        },
        cancelInfop(){
            this.$refs.isAlertShow.closeAlert()
        },
        bankCodeChange(){
            if(!this.bankCode || this.bankCode == '0'){
                this.isBankCode = true
            }else{
                this.isBankCode = false
                dbmap.set('bankCode',this.bankCode)
                if(this.stream){
                    dbmap.set('stream',this.stream)
                }
            }
            this.isAllSuccess()
        },
        isAllSuccess(){
            if(!this.isBankCode) {
                this.isAllRrquridSuccess = false
                return false
            }else{
                this.isAllRrquridSuccess = true
                return true
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/view/Index.vue